import { Provider } from '@angular/core';
import {
  RECURRING_TASKS_STORE,
  resolveRecurringTasksStoreMode
} from './recurring-tasks-store.interface';
import { RecurringTasksMockStore } from './recurring-tasks-mock-store.service';
import { RecurringTasksFirestoreStore } from './recurring-tasks-firestore-store.service';

export function provideRecurringTasksStore(): Provider[] {
  return [
    RecurringTasksMockStore,
    RecurringTasksFirestoreStore,
    {
      provide: RECURRING_TASKS_STORE,
      useFactory: (mock: RecurringTasksMockStore, firestore: RecurringTasksFirestoreStore) =>
        resolveRecurringTasksStoreMode() === 'mock' ? mock : firestore,
      deps: [RecurringTasksMockStore, RecurringTasksFirestoreStore]
    }
  ];
}
